import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios"; // Import axios
import { baseurl } from "../../Baseurl"; 
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; 
import AllThumbnail from "./SellerComp/AllThumbnail";
import EditListingNavbar from "./SellerComp/EditListingNavbar";

const EditListingImage = () => {
  const [formData, setFormData] = useState({
    thumbnail: null, // Store only one thumbnail
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // Added loading state
  const navigate = useNavigate();

  // File Format Restriction Validation Array
  const allowedExtensions = ["jpeg", "jpg", "webp", "avif", "gif", "mp4"];

  // File Upload Handling for thumbnail
  const onThumbnailDrop = useCallback((acceptedFiles, fileRejections) => {
    // If react-dropzone filters out standard invalid files, or we manually verify extensions
    if (fileRejections.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Unsupported File Format!",
        text: `Please upload a valid file. Only ${allowedExtensions.join(", ").toUpperCase()} formats are supported.`,
        confirmButtonText: "Ok",
      });
      return;
    }

    if (acceptedFiles.length > 0) {
      const selectedFile = acceptedFiles[0];
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      // Explicit fail-safe manual check for extensions
      if (!allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          icon: "error",
          title: "Unsupported File Format!",
          text: `Please upload a valid file. Only ${allowedExtensions.join(", ").toUpperCase()} formats are supported.`,
          confirmButtonText: "Ok",
        });
        return;
      }

      setFormData({
        thumbnail: selectedFile, // Only store one thumbnail
      });
      setErrors({});
    }
  }, []);

  const { getRootProps: getThumbnailRootProps, getInputProps: getThumbnailInputProps } = useDropzone({
    onDrop: onThumbnailDrop,
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/webp": [".webp"],
      "image/avif": [".avif"],
      "image/gif": [".gif"],
      "video/mp4": [".mp4"],
    },
    multiple: false, // Only allow one file
  });

  const validateForm = () => {
    let formErrors = {};
    if (!formData.thumbnail) formErrors.thumbnail = "Listing File is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const { listing_id, seller_id } = useParams();  
  // console.log("Listing ID from URL:", listing_id);  
  // console.log("Seller ID from URL:", seller_id); 

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (validateForm()) {
      setLoading(true); // Turn on loader
      const formSubmission = new FormData();
      formSubmission.append("thumbnail", formData.thumbnail);
      formSubmission.append("listing_id", listing_id); // Add listing_id to the form data
      formSubmission.append("listing_product_id", seller_id); // Add seller_id to the form data
  
      // Log the form data being sent
      const formDataEntries = {};
      formSubmission.forEach((value, key) => {
        formDataEntries[key] = value;
      });
      // console.log("Sent Data:", formDataEntries);  
  
      try {
        const response = await axios.put(`${baseurl}seller/add-thumbnail`, formSubmission, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
  
        // Log the entire response object for debugging
        console.log("Response:", response);
  
        // Check if the status is 201 (created)
        if (response.status === 201) {
          const { message, data } = response.data;
          const { listing_unique_id } = data;
  
       
          Swal.fire({
            icon: 'success',
            title: message,  
            text: 'Your Listing Image has been uploaded and linked to the listing.',
            confirmButtonText: 'Ok',
          }).then(() => {
            window.location.reload();
            // Optionally navigate to the new URL if needed
            // navigate(`/seller/listing-two/${listing_unique_id}`);
          });
        } else {
          console.log("Upload failed. Status code:", response.status);
          // If status is not 201, show an error
          Swal.fire({
            icon: 'error',
            title: 'Upload Failed!',
            text: 'There was an error while uploading the Listing File. Please try again.',
            confirmButtonText: 'Ok',
          });
        }
  
      } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed!',
          text: 'There was an error while uploading the thumbnail. Please try again.',
          confirmButtonText: 'Ok',
        });
      } finally {
        setLoading(false); // Turn off loader when response arrives or errors out
      }
  
      setErrors({});
    }
  };

  // Generate thumbnail preview (Handles fallbacks for video previews safely)
  const getThumbnailPreview = formData.thumbnail ? URL.createObjectURL(formData.thumbnail) : null;
  const isVideo = formData.thumbnail && formData.thumbnail.type.startsWith("video/");

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <EditListingNavbar/>

                <div className="reviewcls text-start">
                  <h4 className="selh1">Listing Images</h4>
                  <hr />

                  <div className="row g-3">
                    <div className="col-md-12">
                      <AllThumbnail/>
                    </div>

                    <div className="col-md-3">
                      <form onSubmit={handleSubmit}>
                        <div className="row g-2">
                          {/* Thumbnail Upload */}
                          <div className="col-md-12"> 
                            <div
                              {...getThumbnailRootProps({
                                className: "dropzone",
                                style: {
                                  border: "2px dashed #ccc",
                                  padding: "20px",
                                  textAlign: "center",
                                  cursor: loading ? "not-allowed" : "pointer", // Reflect pointer events visually
                                  pointerEvents: loading ? "none" : "auto", // Blocks user click actions when loading
                                  width: "157px", // Set fixed width
                                  height: "157px", // Set fixed height for square shape
                                  position: "relative", // Ensure preview appears inside the container
                                  opacity: loading ? 0.6 : 1, // Visual cue for loading
                                },
                              })}
                            >
                              <input {...getThumbnailInputProps()} />
                              <p>Drag and drop your Listing image & Video here, or click to select a file</p>
                              {formData.thumbnail && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                    overflow: "hidden",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#fff"
                                  }}
                                >
                                  {isVideo ? (
                                    <video
                                      src={getThumbnailPreview}
                                      className="p-2 rounded"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                      muted
                                      loop
                                      autoPlay
                                    />
                                  ) : (
                                    <img
                                      src={getThumbnailPreview}
                                      alt="Thumbnail Preview"
                                      className="p-2 rounded"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", // Crop and cover the square shape
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                            {errors.thumbnail && <small className="text-danger">{errors.thumbnail}</small>}
                          </div>

                          <div className="col-md-12 mt-3 text-start">
                            <button
                              type="submit"
                              className="btn submitbtnn me-2"
                              disabled={!formData.thumbnail || loading} // Disable during loading state
                            >
                              {loading ? "Uploading..." : "Upload"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>              
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EditListingImage;